<template>
    <div class="animated fadeIn">     
        <b-card>
            <div slot="header">Report Trial Balance 
                <div class="card-header-actions">
                <button class="btn btn-primary mr-1" @click="process()">
                    <i class="fa fa-play"></i>
                    Process
                </button>
                <button class="btn btn-primary mr-1" @click="print()">
                    <i class="fa fa-print"></i>
                    print
                </button>
                <button class="btn btn-primary mr-1" @click="exportxls()">
                    <i class="fa fa-file-excel-o"></i>
                    Export
                </button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row >
                <b-col lg="5">
                  <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Periode Date</span></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl1" type="date" style="padding-right:1px !important;"></b-form-input>
                        <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl2" type="date"  :state="!$v.filter.tgl2.$error" style="padding-right:1px !important;"></b-form-input>
                  </b-input-group>
                  <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Exclude Account</span></b-input-group-prepend>
                          <b-form-checkbox class="ml-1 mt-2 text-left" v-model="filter.excludeheader" value=1 unchecked-value=0 >Header Account</b-form-checkbox>
                          <b-form-checkbox class="ml-3 mt-2 text-left" v-model="filter.excludekosong" value=1 unchecked-value=0 >No Balance & No Transaction</b-form-checkbox>
                  </b-input-group>
                </b-col>
                <b-col lg="7">
                  <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Account</span></b-input-group-prepend>
                        <b-form-input readonly v-model="filter.kodeawinfo" ></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="showLkuCoa('kodeaw')">
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                        <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                        <b-form-input readonly v-model="filter.kodeakinfo" ></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="showLkuCoa('kodeak')">
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                  </b-input-group>
                </b-col>
            </b-row >
            <b-card no-body>
                <div class="report-wraper">
                    <table style="width: 100%;">
                        <thead>
                            <tr>
                            <th width="110px">Account Code</th>
                            <th >Account Name</th>
                            <th style="text-align:right" width="160px">Begining Bal.</th>
                            <th style="text-align:right" width="160px">Debit</th>
                            <th style="text-align:right" width="160px">Credit</th>
                            <th style="text-align:right" width="160px">Ending Balance</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in rptLines" :key="row.kodeacc" @click="drillGL(row)">
                            <td :class="row.kelas">{{row.kodeacc}}</td>
                            <td :class="row.kelas"><span v-html="row.accname"></span></td>
                            <td :class="row.kelas" style="text-align:right">{{row.awal | numFormat}}</td>
                            <td :class="row.kelas" style="text-align:right">{{row.debet | numFormat}}</td>
                            <td :class="row.kelas" style="text-align:right">{{row.kredit | numFormat}}</td>
                            <td :class="row.kelas" style="text-align:right">{{row.sakhir | numFormat}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-card>
        </b-card>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe :src="reportUrl" frameborder="0"></iframe>
        </b-modal>
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun" :allowHeader="true"></lku-coa>
        </b-modal>        
    </div>
</template>

<style lang="scss" scoped>
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;

        table {
            font-size: smaller;
            th {
                border-bottom: 1px solid #D1D1D1;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            td {
                border-bottom: 1px solid #f5f5f5;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
            
            td.total {
                border-top: 2px solid #000 !important;
                background: #e6e6e6 !important;
            }
            
            td.grdtotal {
                border-top: 2px solid #000!important;
                border-bottom: 2px double #000 !important;
                background: #e6e6e6 !important;
            }
        }
    }
 
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import lkuCoa from "../lookup/lkuCoa";
import tb from "../../apis/tb";
import toastr from "mini-toastr";
import moment from 'moment';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      filter: {tgl1:'',tgl2:'', excludeheader:0, excludekosong:0},
      isLoading: false,
      horizontal: true,
      reportUrl: `${location.origin}/#load`,
      showReport:false,
      tahun:moment(this.$store.state.user.tglaktif).format('YYYY'),
      lkuCoaShow:false,
      lkuCoaCaller:'kodeaw',
      rptLines:[]
    };
  },
components: { Loading, lkuCoa },  
computed:{
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
  },
created: async function (){
    if (this.$route.params.tgl1 && this.$route.params.tgl2 && this.$route.params.kodeaw) {
        this.filter.kodeaw = this.$route.params.kodeaw;
        this.filter.kodeak = this.$route.params.kodeak;
        this.filter.kodeawinfo = this.$route.params.kodeaw;
        this.filter.kodeakinfo = this.$route.params.kodeak;
        this.filter.tgl1=this.$route.params.tgl1;
        this.filter.tgl2=this.$route.params.tgl2;
        this.process();
    } else {
         var tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        this.filter.tgl1=`${tgl2.format('YYYY-MM')}-01`;
        this.filter.tgl2=tgl2.format('YYYY-MM-DD');
        this.tahun=tgl2.format('YYYY');
    }
},
methods:{
    updateTgl1: function() {
        var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
        this.filter.tgl1=`${tgl2.format('YYYY-MM')}-01`;
        this.tahun=tgl2.format('YYYY');
        // this.$forceUpdate();
    },
    process: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            const model = {};
            for (var key in this.filter) {
                model[key] = this.filter[key];
            }
            model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
            model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
            const thnAwal=moment(this.filter.tgl1).format('YYYY');
            const thnAkhir= moment(this.filter.tgl2).format('YYYY');
            if ((thnAwal !== thnAkhir) || (model.tgl1 >= model.tgl2)) {
                toastr.error('Date range is invalid');
                return;
            }                            
            this.isLoading=true;
            try {
                this.rptLines= await tb.rpttb(model);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            }
       }
    },
    print: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            const model = {};
            for (var key in this.filter) {
                model[key] = this.filter[key];
            }
            model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
            model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
            const thnAwal=moment(this.filter.tgl1).format('YYYY');
            const thnAkhir= moment(this.filter.tgl2).format('YYYY');
            if ((thnAwal !== thnAkhir) || (model.tgl1 >= model.tgl2)) {
                toastr.error('date range YEAR is invalid');
                return;
            }                            
            try {
                this.showReport=true;
                this.reportUrl= await tb.rpttbprint(model);
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
            } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            }
       }
    },
    exportxls: async function() {
        if (this.invalidFilter) {
            console.log('model obj : ',this.filter);
            toastr.error('Please fill the form correctly.');
       } else {
            const model = {};
            for (var key in this.filter) {
                model[key] = this.filter[key];
            }
            model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
            model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
            const thnAwal=moment(this.filter.tgl1).format('YYYY');
            const thnAkhir= moment(this.filter.tgl2).format('YYYY');
            if ((thnAwal !== thnAkhir) || (model.tgl1 >= model.tgl2)) {
                toastr.error('date range YEAR is invalid');
                return;
            }                            
            this.isLoading=true;
            try {
                const response = await tb.rpttbexport(model);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            }
       }
    },
    drillGL: function(data){
        console.log('drill down to GL : ',data);
        // router.push({name :'accounting.gl', params: { kodeaw: data.kodeacc, tgl1:this.filter.tgl1, tgl2: this.filter.tgl2}});
            let routeData = router.resolve({path: `general-ledger/${data.kodeacc}/${this.filter.tgl1}/${this.filter.tgl2}`});
            window.open(routeData.href, '_blank');

    },
    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
        if (this.lkuCoaCaller==='kodeaw'){
            this.filter.kodeawinfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.filter.kodeaw = _selected.kodeacc;
        } else {
            this.filter.kodeakinfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.filter.kodeak = _selected.kodeacc;
        }
        this.lkuCoaShow=false;
        this.$forceUpdate();
    },
    close(){
      router.push("home");
    }
  }
};
</script>
